import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FiCopy } from 'react-icons/fi';
import SyntaxHighlighter from 'react-syntax-highlighter';

import { Context } from '../../contexts/AppContext';

import stylesCSS from './codeblock.module.css';
import styles from './styles';

const CodeBlock = ({ value, language = 'sql' }) => {
  const { createToast } = useContext(Context);

  return (
    <div className={stylesCSS.code__container}>
      <CopyToClipboard
        text={value}
        onCopy={() => createToast('success', 'Copied to clipboard')}
      >
        <button className="focus:outline-none" aria-label="Copy snippet">
          <FiCopy />
        </button>
      </CopyToClipboard>
      <SyntaxHighlighter
        language={language || 'sql'}
        style={styles}
        className="code__block"
        wrapLines={true}
      >
        {value}
      </SyntaxHighlighter>
    </div>
  );
};

CodeBlock.propTypes = {
  value: PropTypes.string.isRequired,
  language: PropTypes.string,
};

export default CodeBlock;
